function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M250,449.81C185.82,385.55,109.5,288.67,109.5,191.4c0-36.86,12.19-71.21,34.33-96.72C169.19,65.44,205.9,50,250,50s80.81,15.45,106.17,44.69c22.14,25.51,34.33,59.86,34.33,96.72C390.5,288.67,314.18,385.55,250,449.81Zm0-313.31A52.5,52.5,0,1,0,302.5,189,52.56,52.56,0,0,0,250,136.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M250,50.49C294,50.49,330.53,65.88,355.8,95a136.06,136.06,0,0,1,25.74,45.19A156.83,156.83,0,0,1,390,191.4c0,44.35-15.93,92.61-47.35,143.45-23,37.28-54.2,75.71-92.65,114.25-38.45-38.54-69.62-77-92.65-114.25C125.93,284,110,235.75,110,191.4a156.83,156.83,0,0,1,8.46-51.2A136.06,136.06,0,0,1,144.2,95C169.47,65.88,206.05,50.49,250,50.49M250,242a53,53,0,1,0-53-53,53.07,53.07,0,0,0,53,53m0-192.51c-96.14,0-141,72.33-141,141.91,0,99.8,79.66,197.77,141,259.11C311.34,389.17,391,291.2,391,191.4c0-69.58-44.86-141.91-141-141.91ZM250,241a52,52,0,1,1,52-52,52,52,0,0,1-52,52Z"
}));

function SvgLocator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocator);
export default __webpack_public_path__ + "static/media/Locator.66798117.svg";
export { ForwardRef as ReactComponent };